<template>
  <ob-modal2 :show.sync="show" :backdrop="false">
    <template slot="modal-title">
      {{IsEdit ? "Update" : "Add"}} Task
    </template>
    <template slot="modal-body">
      <div class="add_task" v-for="(task, index) in TaskList" :key="index+updateVal">
        <div class="divider_line_bank" v-if="index != 0"></div>
        <h4  class="bank-info-header" v-if="TaskList.length > 1 && !IsEdit">
            <span style="font-size:14px;"> Task - {{index+1}} </span><span v-if="task.IsShowDownArrow"><br><br></span>
            <span v-if="task.IsShowDownArrow" style="font-weight:normal;font-size:12px;color:#5d5c65;">{{task.title}}</span>
            <a href="javascript:;" type="link" v-if="task.IsShowDownArrow == false" @click="collapseTask(index)" class="collapse_icon"><i class="fa fa-chevron-up" aria-hidden="true" style="padding-left: 5px;cursor:pointer;"></i></a>
            <a href="javascript:;" type="link" v-if="task.IsShowDownArrow" @click="expandTask(index)" class="collapse_icon"><i class="fa fa-chevron-down" aria-hidden="true" style="padding-left: 5px;cursor:pointer;"></i></a>
            <a href="javascript:;" type="link" v-if="index != 0" @click="removeTask(index), task.IsShowDownArrow = false" class="remove_text">Remove Task</a>
        </h4>
        <div v-if="task.IsShow">
          <div class="row">
            <div class="form-group col-md-6">
              <label>Task Title</label><span class="validation-star">*</span>
              <ob-input :disabled="PreviousData.IsDisableUpdate" v-model.trim="task.title"  placeholder="Enter Task Title" :class="{ 'ob-vuelidate_input-error': $v.TaskList.$each[index].title.$error }" ></ob-input>
              <span class="ob-vuelidate_error-msg" v-if="$v.TaskList.$each[index].title.$dirty && !$v.TaskList.$each[index].title.required">Enter task title</span>
            </div>          
          </div> 
          <div class="row">
            <div class="form-group col-md-12">
              <label>Task Description</label>
              <ob-textarea :disabled="PreviousData.IsDisableUpdate" :class="[PreviousData.IsDisableUpdate ? 'disable_textArea' : '']" v-model.trim="task.description" placeholder="Enter Task Details" :maxLength="1200"></ob-textarea>
            </div>
          </div>       
          <div class="row">    
            <div class="form-group col-md-6">
              <label>Created Date</label><span class="validation-star">*</span>
              <ob-date-time-picker :disabled="PreviousData.IsDisableUpdate" :key="index" v-if="show" :id="`CreatedDate-${index}`" placeholder="Select Date" :options="options1" :inputvalue="task.createdDate"  @updated="(v) => task.createdDate = v" v-model.trim="task.createdDate" :class="{ 'ob-vuelidate_input-error': $v.TaskList.$each[index].createdDate.$error }" ></ob-date-time-picker>
              <span class="ob-vuelidate_error-msg" v-if="$v.TaskList.$each[index].createdDate.$dirty && !$v.TaskList.$each[index].createdDate.required">Select task created date</span>
            </div>
            <div class="form-group col-md-3">
              <label>Estimated Duration</label>
              <ob-input :disabled="PreviousData.IsDisableUpdate" style="width:120px" class="select2_style"  v-number-only placeholder="Enter Hours" v-model.trim="task.estimatedHours"></ob-input>
            </div>
            <div class="form-group col-md-3" style="padding-top:4px;">
              <label></label>
              <ob-input :disabled="PreviousData.IsDisableUpdate" style="width:120px;" :maxLength="2" class="select2_style"  v-number-only placeholder="Enter Minutes" v-model.trim="task.estimatedMinutes"></ob-input>
            </div>
          </div>
          <p v-if="PreviousData.IsDisableUpdate" style="color: #B00020;font-size: 13px;">Note: You do not have permission to edit this task. Please contact your employer.</p>
          <!-- <div class="row">
            <div class="form-group col-md-3">
              <label>Estimated Duration</label>
              <ob-input style="width:120px" class="select2_style"  v-number-only placeholder="Enter Hours" v-model.trim="task.estimatedHours"></ob-input>
            </div>
            <div class="form-group col-md-3" style="padding-top:4px;">
              <label></label>
              <ob-input style="width:120px;" :maxLength="2" class="select2_style"  v-number-only placeholder="Enter Minutes" v-model.trim="task.estimatedMinutes"></ob-input>
            </div>
          </div>   -->
          <div class="row" v-if="IsSupervisor && $route.query.from != null && $route.query.from != '' && !PreviousData.IsDisableUpdate">
            <div class="col-md-12">
                <div class="form-group">
                    <label>Linked Employees <span><img v-tooltip.right="{content: 'Link this same task to other employees.'}" :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_info.svg`"></span></label>
                    <ob-select2 :inModal="true" :key="index" :id="`LinkedEmp-${index}`" :options="empOptions" :initialData="empTypeArray" v-model.trim="task.reportingEmp" :multiple="true" v-if="showEmpList"></ob-select2>
                </div>
            </div>		
          </div>  
        </div>  
        <div class="row" v-if="task.IsShowDownArrow && TaskList.length > 0 && TaskList.length - 1 == index">
          <div class="divider_line"></div>
        </div>  
      </div>
      <div class="row" v-if="IsSupervisor && $route.query.from != null && $route.query.from != '' && !IsEdit && show && TaskList.length > 0" :disabled="TaskList.length >= 5">
        <div v-if="TaskList.length >= 5" :disabled="TaskList.length >= 5" class="add-work-new add-bank-link"> <img  :src="`${CDNIMAGESBASEURL}/ess/ESSApp/Content/Images/blue_plus_icon.svg`" style="cursor: not-allowed;"  v-tooltip.right="{content: 'Maximum 5 Tasks can be added at once.'}"/> <a href="javascript:;" style="text-decoration:underline;cursor: not-allowed;" class="mL0" v-tooltip.right="{content: 'Maximum 5 Tasks can be added at once.'}"> Add More Task</a> </div>
        <div v-else class="add-work-new add-bank-link"> <img  :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/blue_plus_icon.svg`" style="cursor: pointer;" @click ="addSingleTask()" /> <a @click ="addSingleTask()" href="javascript:;" style="text-decoration:underline" class="mL0"> Add More Task</a> </div>
      </div>
    </template>
    <template slot="modal-footer">
      <ob-button type="secondary" @click="cancel()">Cancel</ob-button>
      <ob-button :disabled="PreviousData.IsDisableUpdate" @click="isValid()">{{IsEdit ? "Update" : "Add"}}</ob-button>
    </template>
  </ob-modal2>
</template> 
<script>
import { required, minLength, maxLength, requiredIf, email, alpha, minValue, maxValue } from 'vuelidate/lib/validators'
export default {
  props: ["TraineeEmployeeId","isSupervisor","openModal","IsEdit","PreviousData"],
  data() {
    return {
      
      showCreatedBy:false,
      show: false,
      createdBy:'',
      title:'',
      description:'',
      createdDate:'',
      CreatedByList:'',
      options1: {
        format: 'MM/DD/YYYY',
        dayViewHeaderFormat: 'MM/DD/YYYY',
        ignoreReadonly: true,
        widgetPositioning: {
          horizontal: 'auto',
          vertical: 'bottom'
        }
      },
      options: {
        placeholder: {
          id: "-1",
          text: "Select"
        },
        data: [
        ]
      },
      estimatedHours:'',
      estimatedMinutes:'',
      Hours:'',
      Minutes:'',
      TaskList:[],
      updateVal:0,
      empTypeArray:[],
      IsShowDownArrow:false,
      showEmpList:false,
      empOptions:{
          placeholder: {
            id: '-1', // the value of the option
            text: 'Select',
          },
          data: []
      },
      IsSupervisor:false
    }
  },
  validations() {
    return{
      TaskList :{
        $each: {
          title:{
            required
          },
          // createdBy:{
          //   required
          // },
          createdDate:{
            required
          }
        }
      }
    }
  },
  components: {

  },
  created(){
    this.TaskDetails = this.PreviousData
    this.show = this.openModal
  },
  watch:{
    showModal(val){
      this.show = val
      if(val)
      {
        this.TaskList = []
        this.resetValues()
        this.checkSupervisor()
        //this.fetchCreatedByDetails()
        //this.fetchLinkedEmployeesList()
        if(this.IsEdit){
          this._previousData()
        }
        else{
          this.addBasicTask()
        }
      }
    },
    show(val) {
      this.$emit('update:openModal', val)
    },
    // PreviousData(val)
    // {
    //    this.TaskDetails = val
    //   // this._previousData()
    //   // this.title = val.Title,
    //   // this.description = val.Description,
    //   // this.createdDate = val.CreatedDate,
    //   // this.estimatedHours = val.Hours,
    //   // this.estimatedMinutes = val.Minutes
    // }  
  },
  computed:{
    EmployeeId() { // Handled For ESS and other users
       return this.loggedInUserObj.empId ? this.loggedInUserObj.empId : '';
    },
    showModal(){
      return this.openModal
    }
  },
  methods:{
    checkSupervisor() {
      ajax.get(`Supervisor/IsSupervisor?empId=${loggedInUserObj.empId}`, {}, res => {
          if (res.data){ 
            this.IsSupervisor = res.data;
            this.getTraineeEmployee()
          }
      });
    },
    getTraineeEmployee() {
      this.showEmpList = false
      var EId = this.getEmployeeId();
      ajax.get(`/Supervisor/GetReportingEmployeeList?empId=${loggedInUserObj.empId}`,{}, res => {
        if (res != null && res.data != null && res.data != undefined){
            this.empOptions.data = __.map(res.data.resultList, (t) => {
              if(t.EmployeeId != EId){
                return { 'id': t.EmployeeId, 'text': t.Name}
              }
            })
        }
        this.showEmpList = true
      });
    },
    getEmployeeId(){
      var EId;
      if(this.$route.name == 'employee-tasks-trainee')
      {
        EId = this.$route.query.EmployeeId
      }
      else if(this.IsEdit){
        if(this.$route.name == 'employee-tasks-details' || this.$route.query.id)
        {
            EId = this.$route.query.EmployeeId
        }
        else if(this.$route.name == 'employer-timesheets' || this.$route.name == "employer-addtimesheets" || (this.$route.query && this.$route.query.from == 'employer-timesheets') || (this.$route.query && this.$route.query.from == 'employer-addtimesheets')){
          EId = this.PreviousData.EmployeeId
        }
        else{
            EId = this.EmployeeId
        }
      }
      else{
        EId = this.EmployeeId
      }
      return EId;
    },
    fetchLinkedEmployeesList(){
      this.showEmpList = false
      var EId = this.getEmployeeId();
      ajax.get(`Employee/GetEmployeesListForTasks`, {}, (res) => {
          if (res != null && res.data != null && res.data != undefined){
              this.empOptions.data = __.map(res.data.EmployeeList, (t) => {
                if(t.Id != EId){
                  return { 'id': t.Id, 'text': t.Name}
                }
              })
          }
          this.showEmpList = true
      })
    },
    collapseTask(index){
      if(this.TaskList.length - 1 == index){
        this.$v.TaskList.$touch();
        if(this.$v.TaskList.$invalid == false){
          this.TaskList[index].IsShow = false
          this.TaskList[index].IsShowDownArrow = true
          this.updateVal++
        }
      }
      else{
        this.TaskList[index].IsShow = false
        this.TaskList[index].IsShowDownArrow = true
        this.updateVal++
      }
    },
    expandTask(index){
      this.TaskList[index].IsShow = true
      this.TaskList[index].IsShowDownArrow = false
      this.updateVal++
    },
    addBasicTask(){
      let singleTask = {}
      singleTask.title = ""
      singleTask.description = ""
      singleTask.createdDate = ""
      //singleTask.createdBy = ""
      singleTask.estimatedHours  = ""
      singleTask.estimatedMinutes = ""
      singleTask.reportingEmp = []
      singleTask.IsShow = true
      singleTask.IsShowDownArrow = false
      //singleTask.reportingEmp.push(this.EmployeeId)
      this.TaskList.push(singleTask)
    },
    addSingleTask(){
        this.$v.TaskList.$touch();
        if(this.$v.TaskList.$invalid == false){
            this.addBasicTask()
            this.updateVal++
        }
    },
    removeTask(indexVal){
        this.$v.TaskList.$reset()
        this.TaskList.splice(indexVal,1)
    },
    validateMinutes(val, index){
      var selectedHours = 0
      var selectedMinutes = 0
      this.Hours = 0
      this.Minutes = 0
      selectedHours = (parseInt(selectedHours) || 0) + (parseInt(this.TaskList[index].estimatedHours) || 0) ;
      selectedMinutes = (parseInt(selectedMinutes) || 0) + (parseInt(this.TaskList[index].estimatedMinutes) || 0) ;
      var hours = (selectedMinutes / 60);
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      this.Hours = parseInt(selectedHours) + parseInt(rhours);
      this.Minutes = rminutes;
    },
    resetValues(){
      this.$v.TaskList.$reset()
      this.TaskList = []
      // this.createdBy = '',
      // this.title = '',
      // this.description = '',
      // this.createdDate = '',
      // this.CreatedByList = ''
      // this.$v.createdDate.$reset();
      // this.$v.title.$reset();
      // this.estimatedHours = ''
      // this.estimatedMinutes = ''
      this.Hours = ''
      this.Minutes = ''
    },
    _previousData(){
      this.TaskDetails = this.PreviousData
      // this.title = this.TaskDetails.Title,
      // this.description = this.TaskDetails.Description,
      // this.createdDate = this.TaskDetails.CreatedDate,
      // this.estimatedHours = this.TaskDetails.Hours,
      // this.estimatedMinutes = this.TaskDetails.Minutes,
      this.TaskList = []
      let singleTask = {}
      singleTask.title = this.TaskDetails.Title
      singleTask.description = this.TaskDetails.Description
      singleTask.createdDate = this.TaskDetails.CreatedDate
      singleTask.estimatedHours  = this.TaskDetails.Hours
      singleTask.estimatedMinutes = this.TaskDetails.Minutes
      singleTask.reportingEmp = this.TaskDetails.EmployeeIdList
      //singleTask.createdBy = this.TaskDetails.CreatedBy
      singleTask.IsShow = true
      this.TaskList.push(singleTask)
    },
    fetchCreatedByDetails()
    {
      this.$loading({
        'loadingText': 'Loading...'
      })
      var EId = this.getEmployeeId();
      this.showCreatedBy = false
      ajax.get(`/Task/${EId}/GetTaskCreatedDetails`,{},(res)=>{
        this.CreatedByList = res.data.UserDetails;
        this.options.data = __.map(res.data.UserDetails, (t) => {
          return { 'id': t.Id, 'text': t.FirstName +" "+ t.LastName  }
        })
        this.showCreatedBy = true
		    if(this.IsEdit && this.TaskDetails != null && this.TaskDetails.CreatedBy != null)
        {
          this.createdBy =  this.TaskDetails.CreatedBy != null ? this.TaskDetails.CreatedBy.Id : "";
        }
        else if(this.$route.name == 'employee-tasks-trainee')
        {
          var supervisorDetails = this.CreatedByList.filter(v=>v.Email == this.loggedInUserObj.email)
          if(supervisorDetails != null){
            this.createdBy = supervisorDetails[0].Id
          }else{
            this.createdBy = this.options.data[0].id
          }
        }
        else if(this.options.data.length > 0 && !this.IsEdit){
          this.createdBy = this.options.data[0].id
        }
        if(this.IsEdit == false){
          this.addBasicTask()
        }
        this.$loading({}).close()
      })
    },
    cancel(){
      this.resetValues()
      this.show = false
      this.$emit('close')
    },
    isValid() {
      var EId = this.getEmployeeId();
      this.$v.TaskList.$touch()
      // this.$v.title.$touch();
      // this.$v.createdBy.$touch();
      // this.$v.createdDate.$touch();
      if(this.$v.TaskList.$error == false){
        this.$loading({
          'loadingText': 'Loading...'
        })
        var list = []
        var taskListObj = {}
        var Obj = {}
        this.TaskList.forEach((task, index) =>{
          //var createdBySelectedIndex = this.CreatedByList.map(e => e.Id).indexOf(task.createdBy);
          this.validateMinutes(task.estimatedMinutes, index)
          if(task.reportingEmp && task.reportingEmp != null && task.reportingEmp != ''){
            task.reportingEmp.push(EId)
          }
          else{
            task.reportingEmp = []
            task.reportingEmp.push(EId)
          }
          Obj =  {
            "Title": task.title,
            "Description":task.description,
            "CreatedDate": task.createdDate,
            //"CreatedBy": this.CreatedByList[createdBySelectedIndex],
            "Hours": this.Hours,
            "Minutes": this.Minutes,
            "EmployeeIdList": task.reportingEmp,
            "IsFromESS": !(this.$route.query.from != null && this.$route.query.from != '')
          }
          list.push(Obj)
        })
        taskListObj = {
          "Data": list
        }
        if(this.IsEdit){
          this.editTask(Obj)
        }else{
          this.addTask(taskListObj)
        }        
        this.show = false
      }else{
        this.show = true
      }
      this.$emit('close')
    },
    addTask(obj){
      ajax.post(`/Task/Add?empOrgId=${this.loggedInUserObj.orgId}`,obj, (res) => {
        if(res.data.State == true) {
          this.$message({
            type: 'success',
            message: ResourceCore.Messages["Task_added"]
          });
          this.$parent.$parent.fetchData('taskAdded')
          this.$loading({}).close();
        }else if(res.data.State == false){
          this.$loading({}).close();
          res.data.state = false;
           res.data.HasRestriction = true
          this.ESSEnableDisable(res)
          this.$message({
              type: 'error',
              message: res.data.Message
          });
        }
      });
    },
    editTask(obj){
      var TaskId = this.TaskDetails.TaskId
      ajax.put(`/Task/${TaskId}/Update`, obj , (res) => {
        if(res.data.State == true) {
          if(this.$route.name == 'employee-tasks-details' && this.$route.query.id){
            this.$parent.$parent.fetchTaskDetails(obj)
            this.$parent.$parent.handlingLocalObject(obj)
          }
          else{
            if(this.$route.name == "employee-addtimesheets" || this.$route.name == "employer-addtimesheets" || this.$route.name == "employer-timesheets")
            {
              obj['TaskId'] = TaskId;
              this.$emit('HandleAfterTaskUpdate',obj)

              this.$message({
                type: 'success',
                message: ResourceCore.Messages["Task_Update"]
              });
            }
            else{
            this.$parent.$parent.fetchData('edit')
            }
          }
            this.$loading({}).close();
        }else if(res.data.State == false){
          this.$loading({}).close();
          this.$message({
            type: 'error',
            message: res.data.Message
          });
        }
      });
    }
  },
}
</script>
<style>
  .validation-star{
    color: #F31D1D;
  }
</style>
<style lang="scss" scoped>
.select2_style{
    width: 55px;
   display: inline-block;
  }
  .divider_line_bank{
        opacity: 28% !important;
        height: 2px;
        background-color: #131415;
        margin: -5px -15px 0px -15px;
    }
    .divider_line{
        opacity: 28% !important;
        height: 2px;
        background-color: #131415;
        margin: -4px 0px 16px 0px;
    }
    .add-bank-link{
        padding-left: 12px;
        padding-bottom: 15px;
        padding-bottom: 15px;
    }
  .bank-info-header{
        padding: 10px 0;
        color: #143361;
        font-weight: 600;
        margin-top: 11px;
    }
    .pdf-heading-text{
        font-style: italic;
        margin-bottom: 10px;
        font-size: 12px;
    }
    .remove_text{
        margin-top: -2px;
        margin-right: 4%;
        float: right;
        color: #f46363;
        font-size: 13px;
        font-weight: 600;
    }
    .collapse_icon{
        margin-top: -8px;
        margin-right: 1%;
        float: right;
        color: #8b8888;
        font-size: 20px;
        font-weight: 600;
    }
    .disable_textArea{
      cursor: not-allowed;
      background-color: #eee !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Tasks/AddTask.vue